import React from 'react';

const PrivacyPolicy = () => {
  return (
    <>
      <section className="page-header">
        <div className="container">
          <h1>Privacy Policy</h1>
          <p>How we collect, use, and protect your information</p>
        </div>
      </section>

      <article className="section-padding privacy-policy-page">
        <div className="container">
          <section className="policy-section" aria-labelledby="policy-intro">
            <h2 id="policy-intro">1. Introduction</h2>
            <p>
              This Privacy Policy outlines how BSB Fortrade Private Limited (&quot;we&quot;, &quot;our&quot;, or &quot;us&quot;)
              collects, uses, shares, and protects personal information of users (&quot;you&quot;) who access our website and services.
            </p>
          </section>

          <section className="policy-section" aria-labelledby="policy-collect">
            <h2 id="policy-collect">2. Information We Collect</h2>
            <ul>
              <li>
                <strong>Personal Information:</strong> Name, email address, phone number, address, and other contact details.
              </li>
              <li>
                <strong>Business &amp; transaction information:</strong> Company name, GST or tax-related identifiers where
                applicable, delivery and billing details, order and enquiry records, and other information needed to provide
                polymer trading, logistics, and related services.
              </li>
              <li>
                <strong>Technical Information:</strong> IP address, browser type, device information, and usage data.
              </li>
            </ul>
          </section>

          <section className="policy-section" aria-labelledby="policy-use">
            <h2 id="policy-use">3. How We Use Your Information</h2>
            <ul>
              <li>Provide and manage our platform, trading, logistics, and financial support services</li>
              <li>Respond to inquiries and provide customer support</li>
              <li>Improve our website and services</li>
              <li>Send updates, newsletters, and promotional materials (with consent)</li>
              <li>Comply with legal obligations</li>
            </ul>
          </section>

          <section className="policy-section" aria-labelledby="policy-sharing">
            <h2 id="policy-sharing">4. Sharing of Information</h2>
            <p>We do not sell or rent your personal information. We may share your data with:</p>
            <ul>
              <li>Authorised personnel and operational partners involved in delivering our services</li>
              <li>Service providers who assist in our operations</li>
              <li>Legal authorities when required by law</li>
            </ul>
          </section>

          <section className="policy-section" aria-labelledby="policy-security">
            <h2 id="policy-security">5. Data Security</h2>
            <p>
              We implement appropriate technical and organizational measures to protect your data from unauthorized access,
              alteration, disclosure, or destruction. This includes encryption, secure servers, and access controls.
            </p>
          </section>

          <section className="policy-section" aria-labelledby="policy-cookies">
            <h2 id="policy-cookies">6. Cookies and Tracking Technologies</h2>
            <p>
              Our website uses cookies to enhance user experience and analyze traffic. You can control cookie preferences
              through your browser settings.
            </p>
          </section>

          <section className="policy-section" aria-labelledby="policy-rights">
            <h2 id="policy-rights">7. User Rights</h2>
            <ul>
              <li>Access your personal data</li>
              <li>Request correction or deletion of your data</li>
              <li>Withdraw consent at any time</li>
              <li>Lodge a complaint with a data protection authority</li>
            </ul>
          </section>

          <section className="policy-section" aria-labelledby="policy-third-party">
            <h2 id="policy-third-party">8. Third-Party Links</h2>
            <p>
              Our website may contain links to third-party sites. We are not responsible for their privacy practices. Please
              review their policies before providing any personal information.
            </p>
          </section>

          <section className="policy-section" aria-labelledby="policy-changes">
            <h2 id="policy-changes">9. Changes to This Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. Changes will be posted on this page with the updated
              effective date.
            </p>
          </section>
        </div>
      </article>
    </>
  );
};

export default PrivacyPolicy;
